<vl-form-grid mod-stacked>
    <vl-column v-if="showFinancialServiceWarning">
        <vl-alert icon="alert-circle" mod-warning>
            <p>Deze lijst bevat enkel nog facturen & betalingsbewijzen van voor 01/09/2024 (aansluiting op het Clearing House). Sindsdien zijn de facturen en betalingsbewijzen enkel nog beschikbaar op organisatie-niveau.</p>
        </vl-alert>
    </vl-column>

    <vl-column v-if="useCards">
        <vl-button
            @click="filterToggleInCardView = !filterToggleInCardView"
            icon="content-filter"
            mod-icon-before
            :mod-secondary="filterToggleInCardView"
            :mod-tertiary="!filterToggleInCardView"
        >
            Filter
        </vl-button>
    </vl-column>

    <vl-column v-if="showFilter">
        <kl-search-invoices ref="searchInvoices" @search="search" v-if="searchFields.date" />
    </vl-column>

    <vl-column>
        <ippro-datatable
            class="invoices"
            :meta="meta"
            :dataset="invoices"
            :columns="columns"
            :fetching="fetching"
            mod-zebra
            :mod-use-cards="useCards"
            :mod-pagination-on-top="!useCards"
        >
            <template v-slot:noresults>
                <div v-vl-align:center>
                    <vl-u-spacer mod-large />
                    <p v-if="!showUnavailable">Uw zoekopdracht heeft geen resultaten opgeleverd.</p>
                    <p v-if="showUnavailable">De facturen konden niet opgehaald worden bij Clearing House. Probeer later nogmaals opnieuw.</p>
                </div>
            </template>
            <template v-slot:actions>
                <vl-link :href="downloadFileUri"
                         v-if="showDownloadLink"
                        :key="'download-' + downloadFileUri"
                        icon="download-harddisk" mod-icon-before :mod-loading="downloadFileUriLoading" :mod-disabled="downloadFileUriLoading"
                >
                    Download
                </vl-link>
            </template>
            <template v-slot:card="{ row }">
                <kl-invoice-card :invoice-card="row" />
            </template>
        </ippro-datatable>
    </vl-column>
</vl-form-grid>
